import api from './axiosConfig';

const getStoreParam = () => {
  const storeId = localStorage.getItem('accountingClientId')
    || localStorage.getItem('storeId')
    || '';
  return storeId ? { accountingClient: storeId } : {};
};

const waybillAPI = {
  getAll: (params = {}) => api.get('/trucking/waybills', { params: { ...params, ...getStoreParam() } }),
  getById: (id) => api.get(`/trucking/waybills/${id}`),
  create: (data) => api.post('/trucking/waybills', data),
  update: (id, data) => api.put(`/trucking/waybills/${id}`, data),
  delete: (id) => api.delete(`/trucking/waybills/${id}`),
  nextSerial: () => api.get('/trucking/waybills/next-serial'),
  getLines: (id) => api.get(`/trucking/waybills/${id}/lines`),
  addLine: (id, data) => api.post(`/trucking/waybills/${id}/lines`, data),
  updateLine: (id, lineId, data) => api.put(`/trucking/waybills/${id}/lines/${lineId}`, data),
  deleteLine: (id, lineId) => api.delete(`/trucking/waybills/${id}/lines/${lineId}`),
  getPrintToken: (id) => api.post(`/trucking/waybills/${id}/print-token`),
  getByPrintToken: (printToken) => api.get(`/trucking/waybills/print/${printToken}`),
  getDailyWaybill: (params = {}) => api.get('/trucking/waybills/daily-waybill', { params }),
  getRevenuePerVan: (params) => api.get('/trucking/waybills/report/revenue-per-van', { params }),
  getUndeliveredFreightForwarding: (params) => api.get('/trucking/waybills/report/undelivered-freight-forwarding', { params }),
  voidWaybill:        (id, reason) => api.patch(`/trucking/waybills/${id}/void`, { reason }),
  retryWaybillGLPost: (id)         => api.post(`/trucking/waybills/${id}/retry-gl-post`),
  bulkGLPost: (data)               => api.post('/trucking/waybills/bulk-gl-post', data),
  bulkSetPullOutDate: (data)       => api.post('/trucking/waybills/bulk-pull-out-date', data),
  getAuditLog: (id) => api.get(`/trucking/waybills/${id}/audit`),
  getLinkedBillings: (waybillId) => api.get(`/trucking/waybills/${waybillId}/billings`),
};

const uomAPI = {
  getAll: () => api.get('/trucking/unit-of-measure'),
};

const billingUomAPI = {
  getAll:    ()           => api.get('/billing/unit-of-measure'),
  getById:   (id)         => api.get(`/billing/unit-of-measure/${id}`),
  create:    (data)       => api.post('/billing/unit-of-measure', data),
  update:    (id, data)   => api.put(`/billing/unit-of-measure/${id}`, data),
  delete:    (id)         => api.delete(`/billing/unit-of-measure/${id}`),
};

const truckingBillAPI = {
  getAll: (params = {}) => api.get('/trucking/bills', { params: { ...params, ...getStoreParam() } }),
  getById: (id) => api.get(`/trucking/bills/${id}`),
  create: (data) => api.post('/trucking/bills', data),
  update: (id, data) => api.put(`/trucking/bills/${id}`, data),
  delete: (id) => api.delete(`/trucking/bills/${id}`),
  nextNumber: (billTypeId) => api.get('/trucking/bills/next-number', { params: { billTypeId } }),
  addWaybillLine: (billId, waybillId) =>
    api.post(`/trucking/bills/${billId}/add-waybill-line`, { waybillId }),
  checkWaybillUsage: (waybillId) =>
    api.get(`/trucking/bills/waybill-usage/${waybillId}`),
  removeLine: (billId, lineId) =>
    api.delete(`/trucking/bills/${billId}/line/${lineId}`),
  updateLineDateReturn: (billId, lineId, dateReturn) =>
    api.patch(`/trucking/bills/${billId}/line/${lineId}/date-return`, { dateReturn }),
  getAuditLog: (id) => api.get(`/trucking/bills/${id}/audit`),
  voidBill: (id, reason) => api.patch(`/trucking/bills/${id}/void`, { reason }),
  updateStatus: (id, status) => api.patch(`/trucking/bills/${id}/status`, { status }),
  getTruckingPrintToken: (id) => api.post(`/trucking/bills/${id}/print-token`),
  getByPrintToken: (token) => api.get(`/trucking/bills/print/${token}`),
  getDailyBill: (params = {}) => api.get('/trucking/bills/daily-bill', { params }),
  getARSummary: (params = {}) => api.get('/trucking/bills/ar-summary', { params }),
  getARSummaryView: (params = {}) => api.get('/trucking/bills/ar-summary', { params: { ...params, view: 'summary' } }),
  getARCustomerDetail: (customerId, params = {}) => api.get(`/trucking/bills/ar-summary/${customerId}/detail`, { params }),
  getDailyCollection: (date) => api.get('/trucking/bills/daily-collection', { params: { date } }),
  getDailyBill: (params = {}) => api.get('/trucking/bills/daily-bill', { params }),
};

const truckingReportAPI = {
  dailyTrip: (params) => api.get('/trucking/reports/daily-trip', { params }),
  psaccStandard: (billId) => api.get(`/trucking/reports/psacc-standard/${billId}`),
  psaccStripping: (billId) => api.get(`/trucking/reports/psacc-stripping/${billId}`),
  truckingBilling: (billId) => api.get(`/trucking/reports/trucking-billing/${billId}`),
};

export { waybillAPI, truckingBillAPI, truckingReportAPI, uomAPI, billingUomAPI };

export const collectionAPI = {
  addPayment:          (data)            => api.post('/trucking/collections', data),
  getByBill:           (billId)          => api.get('/trucking/collections', { params: { billId } }),
  deletePayment:       (collectionId)    => api.delete(`/trucking/collections/${collectionId}`),
  getDailyCollection:  (params = {})     => api.get('/trucking/collections/daily-collection', { params }),
  getAgeing:           (params = {})     => api.get('/trucking/collections/ageing', { params }),
  voidCollection:      (collectionId)    => api.post(`/trucking/collections/${collectionId}/void`),
  retryGLPost:         (collectionId)    => api.post(`/trucking/collections/${collectionId}/retry-gl-post`),
};

export const truckingReportExtAPI = {
  getDailyTripReport:   (params) => api.get('/trucking/waybills/report/daily-trip',          { params }),
  getPSACCBilling:      (params) => api.get('/trucking/waybills/report/psacc-billing',        { params }),
  getPSACCBillingStrip: (params) => api.get('/trucking/waybills/report/psacc-billing-strip',  { params }),
  getAdditionalStrippingSOANumber: (billId) => api.get('/trucking/waybills/report/psacc-billing-strip/additional-stripping-soa-number', { params: { billId } }),
  previewAdditionalStrippingSOANumber: (billId) => api.get('/trucking/waybills/report/psacc-billing-strip/additional-stripping-soa-number/preview', { params: { billId } }),
  releaseAdditionalStrippingSOANumber: (billId) => api.post('/trucking/waybills/report/psacc-billing-strip/additional-stripping-soa-number/release', { billId }),
  getPSACCSOARegistry:  (params) => api.get('/trucking/waybills/report/psacc-soa-registry',   { params }),
};
